import IntlTelInput from "react-phone-input-2";
import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const Input = styled(materialUI.TextField)`
  display: flex;
  color: ${color.grey9};
  border-radius: 8px;
  min-width: 70px;
  width: 100%;
  background-color: ${(props) => props.style?.color};
  input[value=""]:not(:focus) {
    color: transparent;
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${color.LigthGrey};
    }
  }
  .Mui-disabled {
    background: rgb(242, 244, 248);
    cursor: not-allowed;
  }
`;

export const InputArea = styled.div`
  position: relative;
`;

export const CountText = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #a3a3a6;
  z-index: 10;
  position: absolute;
  bottom: 10px;
  background: ${color.White};
  right: 20px;
`;

export const InputObservacao = styled(materialUI.TextField)`
  display: flex;
  color: ${color.grey9};
  border-radius: 8px;
  min-width: 70px;
  width: 100%;
  background-color: ${(props) => props.style?.color};
  ::placeholder {
    color: red;
  }
`;

export const PositionIcon = styled(materialUI.InputAdornment)``;
export const Helper = styled.small`
  font-size: 12px;
  color: red;
  font-family: Inter;
  margin-left: 12px;
  margin-top: 4px;
`;
interface LabelProps {
  color: string;
}
export const Label = styled.label<LabelProps>`
  font-size: 14px;
  font-family: Inter;
  margin-bottom: 8px;
  color: ${(props) => props.color || color.grey1};
`;
export const InputPhone = styled(IntlTelInput)`
  height: 41px;
  input:focus {
    border: 2px solid #2d5bff !important;
  }
  input:disabled {
    background: rgb(242, 244, 248);
    color: rgba(0, 0, 0, 0.38);
  }
`;
